import { identity } from 'ramda'
import { propOrPath } from '@btime/helpers'
import React from 'react'

import { DataTableColWrapper, DataTableWrapper, Table, TableCol, TableColText, TableContent, TableRow } from './Table'
import Panel from '../../../../packages/kiti/components/structure/Panel'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const DataTableHeaderCol = ({ label, isLastColumn, ...props }) => {
  return (
    <TableCol {...props}>
      <TableColText align={isLastColumn ? 'center' : 'left'}>{label}</TableColText>
    </TableCol>
  )
}

const DataTableCol = ({ format, render, dataIndex, record, index, ...props }) => {
  format = format || identity

  const value = dataIndex ? propOrPath('', dataIndex, record) : record
  const formattedValue = format(value, record, index)

  return (
    <TableCol raw={dataIndex === 0} {...props}>
      {render(formattedValue, record, index, props)}
    </TableCol>
  )
}

const DataTableRow = ({ inPanel, size, columns, record, index }) => {
  return (
    <>
      <TableRow key={`row-${record.id}`} hasSidePadding={inPanel} size={size}>
        {columns.map(({ label, ...column }, colIndex) => {
          const isFirstColumn = colIndex === 0
          const isLastColumn = colIndex === columns.length - 1

          if (isFirstColumn) {
            return (
              <DataTableColWrapper key={`col-${record.id}-${label}`} isFirstColumn={isFirstColumn}>
                <DataTableCol {...column} record={record} index={index} dataIndex={colIndex} />
              </DataTableColWrapper>
            )
          }
          if (isLastColumn) {
            return (
              <DataTableColWrapper key={`col-${record.id}-${label}`} isLastColumn={isLastColumn}>
                <DataTableCol {...column} record={record} index={index} />
              </DataTableColWrapper>
            )
          }
          return <DataTableCol key={`col-${record.id}-${label}`} {...column} record={record} index={index} />
        })}
      </TableRow>
    </>
  )
}

const DataTable = ({ data, columns }) => {
  if (!data?.length) return false

  return (
    <Panel paddingV={0.5} paddingH={1}>
      <DataTableWrapper>
        <Table>
          <TableRow head size="small">
            {columns.map((column, index) => {
              const isFirstColumn = index === 0
              const isLastColumn = index === columns.length - 1

              if (isFirstColumn) {
                return (
                  <DataTableColWrapper key={`head-${column.label}`} isFirstColumn={isFirstColumn} head>
                    <DataTableHeaderCol {...column} />
                  </DataTableColWrapper>
                )
              }
              if (isLastColumn) {
                return (
                  <DataTableColWrapper key={`head-${column.label}`} isLastColumn={isLastColumn} head>
                    <DataTableHeaderCol {...column} isLastColumn={isLastColumn} />
                  </DataTableColWrapper>
                )
              }
              return <DataTableHeaderCol key={`head-${column.label}`} {...column} />
            })}
          </TableRow>
          <TableContent>
            {data.map((record, index) => (
              <DataTableRow key={`row-${record.id}`} record={record} index={index} size="small" columns={columns} />
            ))}
          </TableContent>
          <Separator weight={3} />
        </Table>
      </DataTableWrapper>
    </Panel>
  )
}

export default DataTable
